import { ReactNode, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme, Stack, Typography } from '@mui/material';
import { CustomizedLabel } from 'pages/Projects/StatusLabel';

export function LabelledText({
  label,
  value,
  labelIcon,
  showNewline,
  isShowCustomizedTag,
}: {
  label: string;
  value?: string;
  labelIcon?: ReactNode;
  showNewline?: boolean;
  isShowCustomizedTag?: boolean;
}): ReactElement | null {
  const theme = useTheme();
  const { t } = useTranslation();

  const labelComponent = labelIcon ? (
    <Stack direction="row" style={{ alignItems: 'center' }}>
      <Typography variant="body2" color={theme.palette.grey[500]}>
        {t(label)}
      </Typography>
      {labelIcon ? labelIcon : null}
    </Stack>
  ) : (
    <Typography variant="body2" color={theme.palette.grey[500]}>
      {t(label)}
    </Typography>
  );

  if (!value) {
    return null;
  }

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Stack>
        {labelComponent}

        <Typography
          variant="body2"
          color={theme.palette.common.black}
          sx={{ overflowWrap: 'anywhere', whiteSpace: showNewline ? 'pre-line' : 'normal' }}
        >
          {value}
        </Typography>
      </Stack>
      <CustomizedLabel size="small" isCustomized={isShowCustomizedTag} />
    </Stack>
  );
}
